const {h, render, Component} = require('preact');
const StaticButtonView = require('./static_button')
const LiveChatAvailable =  require('./live_chat_available')

class LiveChat extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
  }

  componentDidMount() {
    this.props.onComponentDidMount()
  }


  render() {
    let contactChannels = this.props.params
    if(contactChannels){
      let liveChatSetting = contactChannels.liveChatSetting
      if(this.props.guestOrder) {
        var guestOrder = this.props.guestOrder
        liveChatSetting.guestQuestion = "\n" + I18n.translate('js.modules.web_2018.order_id_label') + " "+ guestOrder.orderId
        liveChatSetting.firstName = 'Guest';
        liveChatSetting.lastName = 'User';
        liveChatSetting.userEmail = guestOrder.emailId
      }
      return (
        <div>
            <div id="live-chat-container"></div>
            <StaticButtonView liveChatSetting={liveChatSetting}/>
        </div>
      )
    }
  }
}

module.exports = LiveChat
